module.exports = __webpack_public_path__ + "img/digital-ocean-svgrepo-com.b0680461.svg";